export const HOURS = 'hours';

export const MINUTES = 'minutes';

export const SECONDS = 'seconds';
